import image from "../../../assets/images/auth-bg.svg";
import {CloseButton, Col, Row} from "react-bootstrap";
import {Authenticator} from "@aws-amplify/ui-react";
import React, {useEffect, useState} from "react";
import {Link, Navigate} from "react-router-dom";
import AnimatedSuccess from "../../ui/outlet-components/AnimatedSuccess";
import Navbar from "react-bootstrap/Navbar";
import logo from "../../../assets/images/logo.svg";
import {FaAngleDoubleLeft} from "react-icons/fa";
import DatastoreInit from "./DatastoreInit";

export default function Register(props) {
    const [state, setState] = useState({position: 'bottom', registerIn: false})
    useEffect(() => {
        setTimeout(() => {
            setState({position: ''})
        }, 100)
        setTimeout(() => {
            setState({registerIn: true})
        }, 3000)
    }, [])
    const Heading = () => {
        return <div className="position-relative">
            <img src={image} alt={"Sussd Auth Background Image"}/>

            {props?.onClose && (<CloseButton variant="white" onClick={props.onClose}/>)}
        </div>
    }
    const components = {
        Header: Heading
    }
    const formFields = {
        signUp: {
            given_name: {
                order: 1,
            },
            phone_number: {
                order: 2,
                dialCode: '+353'
            }
        }
    }
    return (
        <div className="position-relative">
            {!state.registerIn && (
                <>
                    <Navbar bg="light" className="bg-white border-bottom">
                        <div className="container-lg d-flex justify-content-center align-items-center">
                            <Navbar.Brand as={Link} to="/">
                                <img alt="Sussd Logo" src={logo} style={{maxHeight: '60px',}}/>
                            </Navbar.Brand>
                        </div>
                    </Navbar>
                    <Row className="d-flex justify-content-center mt-5 pt-5 position-relative">
                        <Col md={6} lg={5} xl={4}>
                            <div className={`text-center question-transition ${state.position}`}>
                                <div className="transitionable d-inline-block">
                                    <AnimatedSuccess/>
                                </div>
                                <h2 className="text-info mb-5 transitionable delay-7">Great Job!</h2>
                                <h3 className="text-muted mb-3 transitionable delay-10">Now let's set you up with an
                                    account</h3>
                            </div>
                        </Col>
                    </Row>
                </>
            )}
            {state.registerIn && (
                <div className="position-absolute" style={{top: 0, left: 0, right: 0}}>
                    <div className="position-relative amplify-classes mt-5 no-tabs ">
                        <div className="d-flex justify-content-center">

                            <Authenticator initialState="signUp"
                                           components={components}
                                           formFields={formFields}
                                           signUpAttributes={[
                                               'email',
                                               'given_name',
                                               'phone_number',
                                           ]}>
                                <DatastoreInit values={props.values}/>
                            </Authenticator>

                        </div>
                        {/*<div className="text-center mt-5">*/}
                        {/*    <button className="btn btn-secondary" onClick={props.onBack}> <FaAngleDoubleLeft/> Back</button>*/}
                        {/*</div>*/}

                    </div>
                </div>
            )}

        </div>

    );

}